export * from './Footer.styled';
